<template>
  <div>
    <el-form :model="indexData" label-position="top">
      <el-row class="title-bar">
        <el-col :span="12">
          <div class="title-h4">구성 필드</div>
        </el-col>
        <el-col :span="12" align="right">
          <el-button type="primary" size="mini" @click="addField">필드 추가</el-button>
        </el-col>
      </el-row>
      <el-row class="mr-b25">
        <!-- 저장소 필드 테이블 -->
        <el-table-wrapper :column-default="columnDefault" border :data="fieldList" :columns="fieldColumns" :pagination="false"
          :show-custom-header="false" ref="fieldTable" header-align="center" highlight-current-row>
          <template slot-scope="scope" slot="fieldId-slot">
            <span v-if="scope.row.addField">
              <el-input v-model="scope.row.fieldId"></el-input>
            </span>
            <span v-else>
              {{scope.row.fieldId}}
            </span>
          </template>
          <template slot-scope="scope" slot="fieldName-slot">
            <span v-if="scope.row.addField">
              <el-input v-model="scope.row.fieldName"></el-input>
            </span>
            <span v-else>
              {{scope.row.fieldName}}
            </span>
          </template>
          <template slot-scope="scope" slot="mapping-slot">
            <el-checkbox v-model="scope.row.mappingFlag" true-label="Y" false-label="N"/>
          </template>
          <template slot-scope="scope" slot="fieldType-slot">
            <span v-if="scope.row.addField">
              <el-select v-model="scope.row.fieldType">
                <el-option
                  v-for="item in fieldTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </span>
            <span v-else>
              {{scope.row.fieldType}}
            </span>
          </template>
          <template slot-scope="scope" slot="index-order-slot">
            <el-row>
              <i class="fas fa-angle-up c-pointer" v-show="scope.$index > 0" @click="setItemPosition(scope.$index, true)"></i>
            </el-row>
            <el-row>
              <i class="fas fa-angle-down c-pointer" v-show="scope.$index < fieldList.length - 1" @click="setItemPosition(scope.$index, false)"></i>
            </el-row>
          </template>
          <template slot-scope="scope" slot="delete-row-slot">
            <span class="c-pointer" v-if="scope.row.defaultFlag !== 'Y'" @click="deleteFieldRow(scope)"><i class="fal fa-times"></i></span>
          </template>
        </el-table-wrapper>
      </el-row>
      <el-row class="mr-b25" type="flex" justify="center">
        <!-- 필드 추가 버튼 -->
        <el-button icon="fas fa-caret-up" @click="setFieldOption"></el-button>
      </el-row>
      <el-row>
        <!-- 필드 옵션 테이블 -->
        <el-row class="vertical-center-box mr-b15">
          <el-col :span="9">
            <div class="title-h4">필드 옵션</div>
          </el-col>
          <el-col :span="5">
            <el-select v-model="selectedSearchType" placeholder="검색유형" class="mr-r4">
              <el-option
                v-for="item in searchOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="10">
            <w-search-field ref="groupSearch" @search="searchField"/>
          </el-col>
        </el-row>
        <el-table-wrapper :column-default="columnDefault" border :data="tableData" :columns="fieldOptionColumns" :pagination="true"
          :show-custom-header="false"  ref="fieldTable" header-align="center" highlight-current-row @selection-change="selectFieldOption"></el-table-wrapper>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { differenceWith, isEqual, findIndex, isNil, isEmpty, cloneDeep } from 'lodash';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import WSearchField from '@/components/form/SearchField';

export default {
  name: 'WIndexFieldSetting',
  props: {
    indexData: {
      type: Object,
    },
    fieldOptionData: {
      type: Array,
    },
    fieldData: {
      type: Array,
    },
  },
  components: {
    WSearchField,
  },
  data() {
    return {
      selectedSearchType: 'fieldId',
      searchOptions: [
        { value: 'fieldId', label: '필드ID' },
        { value: 'fieldName', label: '필드명' },
        { value: 'fieldType', label: '자료형' },
      ],
      searchText: '',
      tableData: [],
      columnDefault,
      fieldList: [],
      selectField: [],
      fieldTypeList: [
        { label: 'Text', value: 'text' },
        { label: 'Keyword', value: 'keyword' },
        { label: 'Long', value: 'long' },
        { label: 'Integer', value: 'int' },
        { label: 'Date', value: 'date' },
      ],
      fieldOptionColumns: [
        {
          headerAlign: 'center',
          align: 'center',
          type: 'selection',
          width: '70',
          prop: 'check_flag',
        },
        {
          prop: 'fieldId',
          label: '필드ID',
          scopedSlot: 'fieldId-slot',
        },
        {
          prop: 'fieldName',
          label: '필드명',
          scopedSlot: 'fieldName-slot',
        },
        {
          prop: 'fieldType',
          label: '자료형',
          scopedSlot: 'fieldType-slot',
        },
      ],
      fieldColumns: [
        {
          prop: 'fieldId',
          label: '필드ID',
          scopedSlot: 'fieldId-slot',
        },
        {
          prop: 'fieldName',
          label: '필드명',
          scopedSlot: 'fieldName-slot',
        },
        {
          prop: 'fieldType',
          label: '자료형',
          scopedSlot: 'fieldType-slot',
        },
        {
          width: '40px',
          align: 'center',
          scopedSlot: 'index-order-slot',
        },
        {
          width: '40px',
          align: 'center',
          scopedSlot: 'delete-row-slot',
        },
      ],
    };
  },
  watch: {
    fieldData: {
      immediate: true,
      deep: true,
      handler() {
        this.fieldList = cloneDeep(this.fieldData);
      },
    },
    fieldOptionData: {
      immediate: true,
      deep: true,
      handler() {
        this.tableData = cloneDeep(this.fieldOptionData);
      },
    },
  },
  methods: {
    searchField(value) {
      this.searchText = value;
      this.tableData = this.fieldOptionData.filter((data) => !this.searchText || data[this.selectedSearchType].toLowerCase().includes(this.searchText.toLowerCase()));
    },
    getFieldList() {
      return this.fieldList;
    },
    setItemPosition(data, isUp) {
      let index = data;
      if (isUp) {
        index -= 1;
      } else {
        index += 1;
      }
      const tempList = cloneDeep(this.fieldList);
      const temp = tempList[index];
      tempList[index] = tempList[data];
      tempList[data] = temp;
      this.fieldList = tempList;
    },
    checkField() {
      let isExist = true;
      const regex = new RegExp('\\W');

      for (let i = 0; i < this.fieldList.length; i += 1) {
        const item = this.fieldList[i];
        const isCheckWord = regex.test(item.fieldId);
        if (isCheckWord) {
          isExist = false;
          this.$message(msgUtil.getCustomResultMsgData('필드ID는 영문/숫자 입력만 가능합니다.', false));
          break;
        }
        const isfield = this.fieldOptionData.find((field) => field.fieldId === item.fieldId);
        if (isEmpty(item.fieldName)) {
          isExist = false;
          this.$message(msgUtil.getCustomResultMsgData('필드명을 입력하세요.', false));
          break;
        }
        if (isEmpty(item.fieldId)) {
          isExist = false;
          this.$message(msgUtil.getCustomResultMsgData('필드ID를 입력하세요.', false));
          break;
        }
        if (!isNil(isfield) && isNil(item.showFlag)) {
          isExist = false;
          this.$message(msgUtil.getCustomResultMsgData('필드 옵션에 중복된 필드ID가 있습니다.', false));
          break;
        }
        const duplicateField = this.fieldList.find((field, index) => field.fieldId === item.fieldId && index !== i);
        if (duplicateField) {
          isExist = false;
          this.$message(msgUtil.getCustomResultMsgData('구성 필드에 중복된 필드ID가 있습니다.', false));
        }
        if (item.fieldId.length > 250 || item.fieldName.length > 250) {
          isExist = false;
          this.$message(msgUtil.getCustomResultMsgData('입력 값은 250자를 넘길 수 없습니다.', false));
        }
      }
      return isExist;
    },
    /**
     * 필드 추가 함수
     * @author leesy918
     */
    addField() {
      const pushData = {
        fieldId: '',
        fieldName: '',
        fieldType: 'text',
        defaultFlag: 'N',
        addField: true,
      };
      this.fieldList.push(pushData);
    },
    /**
     * 선택한 필드 값 적용
     * @author leesy918
     */
    setFieldOption() {
      const pushData = differenceWith(this.selectField, this.fieldList, isEqual);
      pushData.forEach((item) => {
        this.fieldList.push(item);
      });
    },
    /**
     * 필드 옵션값 선택
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    selectFieldOption(data) {
      this.selectField = data;
    },
    /**
     * 저장소 필드 제거 함수
     * @author leesy918
     * @param  {[type]} scope [description]
     * @return {[type]}       [description]
     */
    deleteFieldRow(scope) {
      const index = findIndex(this.fieldList, scope.row);
      if (index !== -1) {
        this.fieldList.splice(index, 1);
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/LogIndex/components/IndexFieldSetting.vue